import { bl_fi_item_label_import_file_helper_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';


export class FiItemCategoryImportFileHelperContainer extends BaseContainerModel {
    bl_fi_item_label_import_file_helper_RowClass: bl_fi_item_label_import_file_helper_RowClass = new bl_fi_item_label_import_file_helper_RowClass();
}